<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { onMount } from 'svelte';
    import { get } from 'svelte/store';

    import AccountList from '../Accounts/AccountList.svelte';
    import { AccountApp } from '../Accounts/AccountApp';
    import { Account } from '../Accounts/Account';
    import { defaultAccount } from '../Accounts/defaultAccount';
    import FilterAccounts from '../Filter/FilterAccounts.svelte';
    import ButtonAddSomething from '../../shared/ButtonAddSomething.svelte';
    import { api } from '../../../stores/api';

    let addMode = false;
    let showFilter: boolean = true;
    let ap: AccountApp = new AccountApp(false);
    let account: Account | null = null;

    onMount(() => {
        ap.prepareData(get(api)).then(() => {
            ap = ap;
        });
    });
</script>

<div class="accounts-tab">
    <div class="actions">
        <div class="actions-filter">
            {#if !addMode && showFilter}
                <FilterAccounts />
            {/if}
        </div>
        <div class="actions-buttons">
            <ButtonAddSomething
                text={$_('Add account')}
                on:click={() => {
                    addMode = !addMode;
                    if (addMode) {
                        account = new Account().set({ ...defaultAccount }, null);
                    } else {
                        account = null;
                    }
                }}
            />
        </div>
    </div>
    <div class="list">
        <AccountList bind:showFilter bind:addMode bind:ap {account} />
    </div>
</div>

<style>
    .accounts-tab {
        display: flex;
        flex-direction: column;
        flex: 1;
        overflow-y: auto;
    }
    .actions {
        display: flex;
        align-items: center;
        justify-content: space-between;
        column-gap: 10px;
    }
    .actions-buttons {
        display: flex;
        justify-content: flex-end;
    }
    .list {
        margin: 20px 0;
        overflow-y: auto;
        flex: 1;
        display: flex;
        flex-direction: column;
    }
</style>
